module.exports = __webpack_public_path__ + "img/product-xingsuan-intro.1c6e9e00.png";